import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-sm">
      <Link to="/" className="flex items-center gap-1 text-foreground-500 transition-colors hover:text-primary-600">
        <i className="ri-home-5-line"></i>首页
      </Link>
      {items.map((item, i) => (
        <span key={`${item.label}-${i}`} className="flex items-center gap-2">
          <i className="ri-arrow-right-s-line text-foreground-300"></i>
          {item.to && i < items.length - 1 ? (
            <Link to={item.to} className="text-foreground-500 transition-colors hover:text-primary-600">
              {item.label}
            </Link>
          ) : (
            <span className="font-medium text-foreground-900">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}